angular.module('listingOverviewModule').component('listingHistory', {
    templateUrl: 'listingHistory/listingHistory.html',
    bindings: {
        isHouse: '@',
        isTownhouse: '@',
        doNotDefer: '@',
		listingPopupUrl: '@',
        rpc: '@',
    },
    controller: ['$sce', '$element', '$timeout', 'crResourcesService', function ($sce, $element, $timeout, crResourcesService) {
        var self = this;
        this.listingHistory = [];
        this.previousHistory = [];
		this.isGuest = G;

        // Initialize schools only when the component is visible
        this.checkVisibilityAndInit = function () {
            if (self.doNotDefer) {
                self.loadListingHistory();
                return;
            }
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {

                        self.loadListingHistory();

                        observer.disconnect(); // Stop observing after initialization
                    }
                });
            });

            observer.observe($element[0]);
        };

        // Initialize component
        this.$onInit = function () {
            // Trust the passed subway HTML for rendering
            self.trustedSubwayHtml = $sce.trustAsHtml(self.subwayHtml);

            // Start visibility check
            $timeout(() => {
                this.checkVisibilityAndInit();
            });
        };

        this.openPriceHistory = function (e) {
            var priceHistoryTabs = document.querySelectorAll('.lst_links .price_history');
            if (!priceHistoryTabs.length) {
                self.showPhistory();
                return;
            }
            priceHistoryTabs.forEach(function(priceHistoryTab) {
                priceHistoryTab.click();
            });
        }

        this.loadListingHistory = function () {
            crResourcesService.get(self.rpc).$promise.then((val) => {
                if (val.items && val.items.length) {
                    let listedShown = false;
                    val.items.forEach((item) => {
                        //if (item.sale_or_rent == 2) return;
                        if (listedShown && item.type != 'sold') return;
                        const { agent, date, price, change, row, type } = item;
                        let text = null;
                        let date_text = date;
                        switch (type) {
                            case 'dec':
                                text = 'Price decrease by <strong class="neg">' + change + '%</strong> to <strong>$' + parseFloat(price).toLocaleString() + '</strong>';
                                break;
                            case 'inc':
                                text = 'Price increase by <strong class="pos">' + change + '%</strong> to <strong>$' + parseFloat(price).toLocaleString() + '</strong>';
                                break;
                            case 'listed':
                                listedShown = true;
								text = '<strong>Listed for $' + parseFloat(price).toLocaleString() +
									(item.ppsqft ? ' (' + item.ppsqft + ')' : '') +
									'</strong>' +
									(item.listing.agent_name ? ' by ' + item.listing.agent_name : '') +
									(item.listing.umbrella_firm_name ? ', ' + item.listing.umbrella_firm_name : '');
								break;
                            case 'sold':
                                if (item.listing) {
                                    date_text = item.listed_date + ' - ' + item.date;
                                    text = '<strong>Listed for ' + item.listed_sale_price +
										(item.listed_ppsqft ? ' (' + item.listed_ppsqft + ')' : '') +
                                        '</strong><br/>' +
                                        (item.listing.agent_name ? 'by ' + item.listing.agent_name : '') +
                                        (item.listing.umbrella_firm_name ? ', ' + item.listing.umbrella_firm_name : '') +
                                        '<br/><strong><i>Sold for $' + parseFloat(price).toLocaleString() + '</i></strong><br/><i>' +
                                        parseFloat(item.days_new_to_sold).toLocaleString() + ' days on market (to closing)</i>';
                                }
                                break;
                            default:
                                text = row;
                        }

                        //if (type === "dec") {
                        // if (type === "listed") {
                        //     text = 'listed';
                        // } else if (type === "dec") {
                        //     text = 'decrease';
                        // } else if (type === "sold") {
                        //     text = 'sold';
                        // }
                        if (text) {
                            let to_push = {
                                date: date_text,
                                text: text
                            }
                            if (type == 'sold') {
                                self.previousHistory.push(to_push);
                            } else {
                                self.listingHistory.push(to_push);
                            }
                        }
                    });
                }
            });
        };

		this.showPhistory = function(tab = 'phistory') {
			if (self.listingPopupUrl) {
				$element.blimp = new BlimpExtV2(null, {
					cache: false,
					draggable: true,
					show_veil: true,
					display: tab,
					fullscreen: true,
					rpc_url: self.listingPopupUrl,
					onFetch: function() {
						_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
					},
					onPostRpc: function() {
						this.add_extra(true);

						Core.compile_html(this._element);
					}
				});
				$element.blimp.handle_link_click();
			}
		};

    }],
});
